// This function extracts today's opening and closing timings from a store's details.
// It checks if opening hours data is available and finds the period matching today's day.
// It formats the open and close times into "HH:MM" format and returns them along with open_now status.
export const getTodayTimings = (storeTimings: any[]) => {
  if (!Array.isArray(storeTimings) || storeTimings?.length === 0) return null;

  const today = new Date();
  const dayOfWeek = today.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

  const todayTiming = storeTimings?.find((t) => t?.day.toLowerCase() === dayOfWeek);

  if (!todayTiming || !todayTiming?.isOpen) {
    return {
      open_now: false,
      openTime: null,
      closeTime: null,
    };
  }

  const now = today?.getHours() * 60 + today?.getMinutes();

  // Convert open/close times to minutes
  const [openHour, openMin] = todayTiming?.openTime?.split(':').map(Number);
  const [closeHour, closeMin] = todayTiming?.closeTime?.split(':').map(Number);

  const openMins = openHour * 60 + openMin;
  const closeMins = closeHour * 60 + closeMin;

  const isOpenNow = now >= openMins && now <= closeMins;

  return {
    open_now: isOpenNow,
    openTime: todayTiming?.openTime,
    closeTime: todayTiming?.closeTime,
  };
};

// export const getTodayTimings = (store: any) => {
//   const opening = store?.placeDetails?.opening_hours;
//   if (!opening || !opening.periods || opening.periods.length === 0) {
//     return null;
//   }

//   const today = new Date().getDay(); // 0 = Sunday, 1 = Monday, etc.
//   const todayPeriod = opening.periods.find((period: any) => period.open.day === today);

//   if (!todayPeriod) {
//     return null;
//   }

//   const formatTime24 = (timeStr: string) => {
//     const hour = parseInt(timeStr.slice(0, 2), 10);
//     const minute = timeStr.slice(2);
//     const hh = hour.toString().padStart(2, '0');
//     const mm = minute.padStart(2, '0');
//     return `${hh}:${mm}`;
//   };

//   const openTime = todayPeriod.open.time ? formatTime24(todayPeriod.open.time) : 'N/A';
//   const closeTime = todayPeriod.close.time ? formatTime24(todayPeriod.close.time) : 'N/A';

//   return { open_now: opening.open_now, openTime, closeTime };
// };
